import { createContext } from "react";

const DF_OT0058Context = createContext();

export { DF_OT0058Context };
